<template>
    <div>
        <el-input
            v-model="currentValue.name"
            class="hide"
            autocomplete="new-password"
            :placeholder="$t.__('common.labels.address_name')"
        ></el-input>
        <div v-if="currentValue.manualMode">
            <slot name="manualAddress" :data="currentValue" :updateCountry="updateCountry">
                <el-form-item prop="line1" class="mt-2">
                    <el-input
                        v-model="currentValue.line1"
                        autocomplete="off"
                        :placeholder="$t.__('common.labels.street')"
                    ></el-input>
                </el-form-item>
                <el-form-item class="mt-2">
                    <el-input
                        v-model="currentValue.line2"
                        autocomplete="off"
                        :placeholder="$t.__('inputs.custom.Address.building_floor')"
                    ></el-input>
                </el-form-item>
                <el-form-item class="mt-2">
                    <el-input v-model="currentValue.line3" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item class="mt-2">
                    <el-input v-model="currentValue.line4" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="postalCode" class="mt-2">
                    <el-input
                        v-model="currentValue.postalCode"
                        autocomplete="off"
                        :placeholder="$t.__('common.labels.postal_code')"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="city" class="mt-2">
                    <el-input
                        v-model="currentValue.city"
                        autocomplete="off"
                        :placeholder="$t.__('common.labels.city')"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="country" class="mt-2">
                    <country-input
                        :defaultValue="{
                            code: currentValue.countryCode,
                            name: currentValue.country,
                        }"
                        @change="updateCountry"
                    >
                    </country-input>
                </el-form-item>
            </slot>
        </div>
        <slot
            name="algoliaWrapper"
            :methods="{ captureAddress, switchMode }"
            :props="$props"
            :data="$data"
        >
            <div :class="{ hide: currentValue.manualMode }">
                <algolia-input
                    :elementName="value._id"
                    placeType="address"
                    @bubble-address="captureAddress"
                ></algolia-input>
                <CompassPlainButton
                    :label="manuallyLabel"
                    class="mt-1 b-0 pl-0"
                    @click="switchMode"
                />
            </div>
        </slot>
    </div>
</template>

<script>
import AlgoliaInput from 'vcomponents/inputs/AlgoliaInput.vue';
import CountryInput from 'vcomponents/inputs/CountryInput.vue';

export default {
    props: {
        manuallyLabel: {
            type: String,
            required: false,
            default: window.i18n.__('Compléter manuellement'),
        },
        modelValue: {
            type: Object,
            required: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            currentValue: {},
        };
    },
    watch: {
        modelValue: function (newVal, oldVal) {
            // watch it
            this.currentValue = newVal;
            this.currentValue.label = oldVal.label;
        },
    },
    created() {
        this.currentValue = this.modelValue;
    },
    methods: {
        captureAddress(data) {
            this.patchAddress(data);
        },
        switchMode() {
            this.currentValue = this.formatAddress(true, this.modelValue);
            this.$emit('update:modelValue', this.currentValue);
        },
        formatAddress(isManual, value) {
            return {
                ...value,
                ...{
                    line1: value.name || value.line1,
                    line2: value.line2,
                    line3: value.line3,
                    line4: value.line4,
                    postalCode: value.postcode || value.postalCode,
                    state: value.administrative,
                    city: value.city,
                    country: value.country,
                    countryCode: value.countryCode ? value.countryCode.toUpperCase() : '',
                    manualMode: isManual,
                },
            };
        },
        updateCountry(data) {
            this.currentValue.country = data.name;
            this.currentValue.countryCode = data.code;
            this.$emit('update:modelValue', this.currentValue);
        },
        patchAddress(item) {
            this.$emit('update:modelValue', this.formatAddress(false, item));
        },
    },
    components: {
        'algolia-input': AlgoliaInput,
        'country-input': CountryInput,
    },
};
</script>
